import { render, staticRenderFns } from "./AttentionDetection.vue?vue&type=template&id=7d6e8c54&scoped=true"
import script from "./AttentionDetection.vue?vue&type=script&lang=js"
export * from "./AttentionDetection.vue?vue&type=script&lang=js"
import style0 from "./AttentionDetection.vue?vue&type=style&index=0&id=7d6e8c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6e8c54",
  null
  
)

export default component.exports